import { useEffect, useState } from "react";

// Tela de abertura animada do SiteSync (e o logotipo desenhado em vetor, usado tambem na tela de bloqueio).
// O desenho foi tracado a partir do icone do app, entao e o mesmo logotipo.

export const SPLASH_BG = "#0C1A35"; // o mesmo azul escuro da tela de abertura nativa do iPhone
const LOGO_VH = 38.8; // tamanho do logo em % da altura da tela (igual ao da abertura nativa)
const INTRO_MS = 1700; // duracao da animacao de entrada
const FADE_MS = 450; // duracao do desaparecimento
const MAX_WAIT_MS = 9000; // se o app demorar mais que isso para carregar, a abertura sai mesmo assim

// Desenho do logotipo (caixa de 1024 x 1024, como o icone)
const ARC_D = "M276.0 507.7 274 485 274.6 461.0 277.8 435.0 281.7 417.0 288.0 396.4 297.6 373.0 310.0 350.1 321.9 332.0 335.6 315.0 349.7 300.0 368.0 283.9 388.1 269.0 406.5 258.0 428.0 247.7 449 240 472.0 233.9 485.0 231.8 505.3 230.0 520.5 230.0 546.3 232.0 569.0 235.7 586.6 240.0 610.9 248.0 629.7 256.0 654.3 269.0 672.9 281.0 688.0 292.5 707.7 310.0 723.6 327.0 741 349 752 366 768 396 773.0 395.4 800.0 387.6 802.1 388.0 802.1 390.0 770.2 496.0 768.0 497.1 689.2 422.0 688.5 420.0 689.7 419.0 720.0 410.6 721.4 409.0 721.3 407.0 705.6 380.0 688.7 358.0 671.0 339.7 656.0 326.7 642.8 317.0 623 305 602.5 295.0 579.0 286.7 556.0 280.8 531.0 277.5 508.0 276.7 479.0 278.9 457.0 282.9 440.0 287.6 419.8 295.0 399 305 385.0 313.3 365.9 327.0 351.0 339.7 339.7 351.0 329.3 363.0 316.7 380.0 307.4 395.0 297.3 415.0 291.1 430.0 285.4 447.0 281.5 463.0 279.2 476.0 277.0 504.6ZM371.0 269.1 369.4 268.0 375.0 265.5 375.2 266.0ZM500 787 481.0 787.9 457.0 786.4 445.0 784.2 423.0 778.2 396.6 768.0 376.8 758.0 360.0 748.1 340 734 322.0 718.9 307.7 705.0 292.7 688.0 278.0 668.2 264.0 645.1 252.0 620.2 244 599 238.0 577.7 232.0 545.2 230.1 524.0 230.0 502.8 231.6 481.0 233.9 464.0 238.0 443.8 246 417 253.9 397.0 266.0 373.1 274.0 359.7 281.8 348.0 298.0 327.3 312.2 312.0 333.5 293.0 348.0 281.9 369.0 268.3 370 269 370 270 351.0 285.4 329.0 307.5 315.0 324.8 299.7 348.0 289.2 368.0 278.9 392.0 271.0 418.6 267.4 436.0 265.3 451.0 264.1 475.0 265.2 504.0 268.9 529.0 275.4 555.0 282.9 577.0 302.8 618.0 314.5 638.0 329.0 657.7 348.0 678.4 366.9 695.0 387.0 709.2 399.0 716.4 411.0 722.5 431.0 730.9 457.2 739.0 481.0 743.3 493.0 744.6 510.0 745.2 529.0 744.7 541.0 743.3 565.1 739.0 591 731 614.0 721.2 635.0 709.5 655.7 695.0 671.8 681.0 691.0 660.7 693.0 659.9 688.0 668.8 676.0 686.3 659.0 706.9 636.1 729.0 622.0 740.3 611 748 598.2 756.0 578.9 766.0 553.0 776.2 532.7 782.0 512.0 785.8ZM553.0 789.1 546.0 789.7 545.7 789.0 565.0 782.2 584.0 774.5 606.0 762.8 621.0 753.2 642.0 737.1 658.2 722.0 669.0 710.7 683.4 693.0 695.3 676.0 705.0 659.5 716.7 635.0 724.8 613.0 729.7 595.0 738.8 567.0 742.6 547.0 745 526 748.0 525.1 790.0 525.3 791.7 528.0 788 560 782.2 586.0 774 611 764.0 633.9 752.1 656.0 738.7 676.0 719.2 700.0 700.0 719.3 679.6 736.0 659.0 750.2 638 762 610.9 774.0 593.7 780.0 570.0 786.1Z";
const LEFT_D = "M451.0 717.3 448.0 715.7 437.0 712.5 435.8 711.0 436.4 526.0 435.0 524.4 412.0 514.6 410.0 514.4 408.0 512.9 398.0 509.3 396.0 507.8 393.0 507.2 386.9 504.0 386.5 460.0 387.0 458.5 389.2 457.0 451.0 420.5 452.0 420.7 452.3 422.0 452.2 716.0ZM386.0 684.9 370.0 672.5 351.0 653.8 341.0 641.7 330.8 627.0 330.7 540.0 332.0 536.9 386 505 386.5 684.0Z";
const MAIN_D = "M528.0 725.1 515.0 725.8 513 725 513.1 576.0 512.0 574.3 485.5 592.0 485.6 723.0 485.0 724.2 483.0 724.3 477.0 722.6 472.0 722.2 470.9 721.0 471.1 375.0 469.0 374.2 452.0 374.4 451.4 376.0 451.7 394.0 451.0 395.1 410.0 395.3 408.3 395.0 407.6 394.0 407.6 355.0 408.4 354.0 490 298 496.0 296.8 500.0 297.8 502.0 299.3 505 300 527.0 309.5 529.9 310.0 532.0 311.5 542.0 314.8 557.0 321.6 559.0 321.7 561.0 323.1 572.0 326.9 574.0 328.4 589.0 333.7 599.0 338.4 602.0 338.9 604.0 340.5 619.0 345.7 634.0 352.5 656.0 360.7 656.6 362.0 656.7 373.0 656.0 374.1 625.0 374.1 623.4 375.0 623.4 423.0 653.0 444.3 655 445 679.0 461.7 683.5 466.0 683.4 640.0 671.1 655.0 669.0 656.4 668.6 473.0 668.0 471.9 624.0 441.5 623.4 443.0 623.4 694.0 613.0 700.2 592.0 710.2 572.0 717.2 569.0 717.1 568.3 444.0 570.0 442.6 580.0 439.5 583.0 437.7 594.0 434.2 596.0 432.8 599.0 432.3 609.0 427.8 612.0 427.3 613.4 426.0 613.7 375.0 612.0 374.1 529.0 374.2 527.7 375.0 528 547 527.0 548.5 512.8 539.0 513.1 524.0 512.0 522.3 511.0 522.7 509.0 525.6 485.6 549.0 485.4 571.0 486.0 572.8 488.0 572.5 513.0 555.6 553.5 582.0 553.5 721.0 553.0 722.2 547.0 722.5 541.0 724.2ZM610.6 359.0 610.8 358.0 610.0 357.5 607.0 357.2 605.0 355.8 595.0 352.3 575.0 343.6 565.0 340.4 563.0 338.8 553.0 335.3 550.0 333.5 548.0 333.3 538.0 328.7 535.0 328.3 533.0 326.7 523.0 323.3 520.0 321.5 518.0 321.3 510.8 318.0 508.9 318.0 509.4 321.0 525.0 359.3ZM472.8 359.0 478.4 339.0 478.7 335.0 480.3 332.0 482.5 323.0 482.0 321.6 481.0 321.5 472.6 328.0 427.9 358.0 428.1 359.0 430.0 359.5ZM509.2 359.0 509.4 358.0 507.7 356.0 502.3 341.0 500.8 339.0 497.6 329.0 496.0 328.1 492 344 490.7 347.0 488.5 359.0ZM512.3 397.0 513 396 512.8 375.0 512.0 374.1 491.0 374.2 490.1 375.0 490.4 376.0 497.1 382.0 511.0 396.7ZM487.4 439.0 509.5 417.0 509.7 416.0 488.0 393.7 486.0 392.6 485.4 394.0 485.4 439.0 486.0 439.7ZM512.4 484.0 512.9 483.0 512.9 436.0 512.0 434.5 487.8 459.0 488.6 461.0 511.0 483.8ZM487.5 527.0 509.2 505.0 510.4 503.0 486.0 478.9 485.4 480.0 485.4 527.0 486.0 527.9Z";
const ARC_CX = 511.4;
const ARC_CY = 509.5;

export const SPLASH_CSS = `
@keyframes ss-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@keyframes ss-hop { 0% { transform: translateY(0); } 35% { transform: translateY(-16px); } 70% { transform: translateY(3px); } 100% { transform: translateY(0); } }
@keyframes ss-rise { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes ss-bar { from { transform: scaleX(0); } to { transform: scaleX(1); } }
@keyframes ss-pulse { 0%, 100% { opacity: .55; } 50% { opacity: 1; } }
@keyframes ss-out { from { opacity: 1; transform: scale(1); } to { opacity: 0; transform: scale(1.04); } }
.ss-arc.ss-run { animation: ss-spin 1.25s cubic-bezier(.6, 0, .2, 1) .3s both; }
.ss-left.ss-run { animation: ss-hop .8s cubic-bezier(.3, .7, .4, 1) .75s both; }
.ss-main.ss-run { animation: ss-hop .8s cubic-bezier(.3, .7, .4, 1) .9s both; }
.ss-word { animation: ss-rise .7s ease-out 1s both; }
.ss-track { animation: ss-rise .5s ease-out 1.1s both; }
.ss-fill { transform-origin: left center; animation: ss-bar 1.4s cubic-bezier(.4, 0, .2, 1) .3s both; }
.ss-waiting .ss-arc.ss-run { animation: ss-spin 2.2s linear infinite; }
.ss-waiting .ss-fill { animation: ss-pulse 1.2s ease-in-out infinite; transform: scaleX(1); }
.ss-leaving { animation: ss-out ${FADE_MS}ms ease forwards; pointer-events: none; }
@media (prefers-reduced-motion: reduce) {
  .ss-arc.ss-run, .ss-left.ss-run, .ss-main.ss-run, .ss-word, .ss-track, .ss-fill, .ss-waiting .ss-arc.ss-run, .ss-waiting .ss-fill { animation: none !important; opacity: 1; transform: none; }
}
`;

// O logotipo. Com run = true as pecas se mexem; sem run fica parado (tela de bloqueio).
export function LogoMark({ run = false, size = `${LOGO_VH}vh`, maxSize = "92vw" }) {
  const cls = run ? " ss-run" : "";
  return (
    <svg
      viewBox="0 0 1024 1024"
      role="img"
      aria-label="SiteSync"
      style={{ width: size, height: size, maxWidth: maxSize, maxHeight: maxSize, display: "block", overflow: "visible" }}
    >
      <g transform={`translate(${ARC_CX} ${ARC_CY})`}>
        <g className={`ss-arc${cls}`}>
          <g transform={`translate(${-ARC_CX} ${-ARC_CY})`}>
            <path d={ARC_D} fill="#F8680F" fillRule="evenodd" />
          </g>
        </g>
      </g>
      <g className={`ss-left${cls}`}>
        <path d={LEFT_D} fill="#FFFFFF" fillRule="evenodd" />
      </g>
      <g className={`ss-main${cls}`}>
        <path d={MAIN_D} fill="#FFFFFF" fillRule="evenodd" />
      </g>
    </svg>
  );
}

export default function SplashScreen({ ready, onDone }) {
  const [introOver, setIntroOver] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(() => setIntroOver(true), reduce ? 400 : INTRO_MS);
    const safety = setTimeout(() => setLeaving(true), MAX_WAIT_MS);
    return () => {
      clearTimeout(t);
      clearTimeout(safety);
    };
  }, []);

  // So sai quando a animacao acabou E o app ja sabe se a pessoa esta logada ou nao.
  useEffect(() => {
    if (introOver && ready) setLeaving(true);
  }, [introOver, ready]);

  useEffect(() => {
    if (!leaving) return undefined;
    const t = setTimeout(onDone, FADE_MS);
    return () => clearTimeout(t);
  }, [leaving, onDone]);

  const waiting = introOver && !ready && !leaving;

  return (
    <div
      className={`${leaving ? "ss-leaving" : ""} ${waiting ? "ss-waiting" : ""}`}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: SPLASH_BG,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
      data-testid="splash-screen"
    >
      <style>{SPLASH_CSS}</style>
      <LogoMark run />
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: `calc(50% + ${(LOGO_VH * (790 - 512)) / 1024}vh + 22px)`,
          textAlign: "center",
          color: "#FFFFFF",
        }}
      >
        <div
          className="ss-word"
          style={{ fontFamily: "'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif", fontSize: 30, fontWeight: 700, letterSpacing: "0.01em" }}
        >
          SiteSync
        </div>
        <div
          className="ss-track"
          style={{ width: 120, height: 3, margin: "16px auto 0", borderRadius: 3, background: "rgba(255,255,255,0.14)", overflow: "hidden" }}
        >
          <div className="ss-fill" style={{ width: "100%", height: "100%", borderRadius: 3, background: "#F8680F" }} />
        </div>
      </div>
    </div>
  );
}
